import React from "react";
import { ColorPicker } from "Source/globalComponents";

class Color extends React.Component {
    constructor(props) {
        super(props);

        _.map(["onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onChange( option ) {
        if( this.props.onChange ) {
            this.props.onChange({ target: { id: "color", value: option.hex }});
        }
    }

    render() {
        return (
            <ColorPicker 
                onSelect={this.onChange} 
                color={this.props.color} 
                placeholder={"#000000"} 
                required={true} 
            />
        );
    }
}

export default Color;
